import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import HeroIconSrc from "shared/assets/images/hero-colors.png";

const HeroPortal: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Hero.S4A_HERO_PORTAL,
    });
  }, []);

  return (
    <div className="greetings full-height">
      <div
        className="background-colors"
        style={{
          backgroundImage: `url(${HeroIconSrc})`,
        }}
      >
        <div style={{ padding: "0 40px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "center",
            }}
            className="height-100"
          >
            <h2>{t("pages.StrmHero.great")}</h2>
            <p className="body-regular" style={{ fontSize: 16 }}>
              <Trans i18nKey={t("pages.StrmHero.portalMessage")} />
            </p>
            <button className="botao-roxo" onClick={() => history.push("/")}>
              {t("pages.StrmHero.goToPortal")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroPortal;
